import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

interface SelectInputProps {
  label: string;
  value: string;
  name: string;
  onChange: (e: any) => void;
  options?: any[];
  required?: boolean;
  isValueId?: boolean;
  hasError?: string | boolean;
  size?: "small" | "medium";
  disabled?: boolean;
  renderValue?: (value: any) => React.ReactNode;
}

function SelectInput({
  label,
  value,
  name,
  onChange,
  size,
  hasError,
  required,
  options,
  isValueId = false,
  disabled = false,
  ...props
}: SelectInputProps) {
  return (
    <FormControl
      fullWidth
      required={required}
      size={size}
      error={required && !!hasError && !value}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        labelId={`${name}-label`}
        id={`${name}-select`}
        value={value}
        onChange={onChange}
        label={label}
        size={size}
        disabled={disabled}
        {...props}
      >
        {options &&
          options.map((option, idx) => (
            <MenuItem
              key={idx}
              value={isValueId ? option.value : option}
              className="text-capitalize"
            >
              {isValueId ? option.name : option}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>{hasError}</FormHelperText>
    </FormControl>
  );
}

export default SelectInput;
